import {AppRoutes} from "../../utils/constants";
import {Container, Nav, Navbar} from "react-bootstrap";
import {useEffect, useState} from "react";
import NavbarProfile from "./navbar-profile";
import {Link} from "react-router-dom";
import {useAuth} from "../../context/auth";

export default function Header(props) {

    const [expanded, setExpanded] = useState(true);
    const auth = useAuth();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
            {threshold: [1]}
        );
        observer.observe(document.querySelector('nav'));
    }, []);


    const handleCollapse = (e) => {
       // e.preventDefault();

    };


    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navbar-custom topnav-navbar sticky-top">
                <Container>
                    <Navbar.Brand>
                        <Nav.Link as={Link} eventKey={1} className="nav-link" onClick={(e)=>handleCollapse(e)} to={AppRoutes.landing.path}>
                             <span className="topnav-logo">
                              <img src="/assets/images/logo-colored.svg" alt="" height="74" />
                            </span>
                        </Nav.Link>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav" className={"justify-content-end"}>
                        <Nav className="align-items-center gap-3 me-0">

                            <Nav.Link as={Link} eventKey={2} className="nav-link" onClick={(e)=>handleCollapse(e)} to={AppRoutes.home.path}>Discover</Nav.Link>
                            <Nav.Link as={Link} eventKey={3} className="nav-link" onClick={(e)=>handleCollapse(e)} to={AppRoutes.following.path}>Following</Nav.Link>
                            <Nav.Link as={Link} eventKey={4} className="nav-link" onClick={(e)=>handleCollapse(e)} to={AppRoutes.schedule.path}>Schedule</Nav.Link>
                            <Nav.Link as={Link} eventKey={5} className="nav-link position-relative" onClick={(e)=>handleCollapse(e)} to={AppRoutes.inbox.path}>
                                Inbox {auth?.unreadMessagesCount>0 && <span className="badge bg-danger position-absolute top-0 start-100 translate-middle badge rounded-pill">{auth.unreadMessagesCount}</span>}</Nav.Link>

                            <span className="nav-line"></span>

                            {/*<NavDropdown title={t('nav.title.info')} id="info">*/}
                            {/*    <NavDropdown.Item href="#info">{t('nav.title.info')}</NavDropdown.Item>*/}
                            {/*</NavDropdown>*/}
                            {/*<span className="nav-line"></span>*/}
                            <NavbarProfile />
                        </Nav>
                        {/*<Nav className="align-items-center gap-3 p-3 p-lg-0">*/}
                        {/*    <Nav.Item>*/}
                        {/*        <Button variant="dark" className="px-5 btn-lg" href={AppRoutes.contact.path}>Contact</Button>*/}
                        {/*    </Nav.Item>*/}
                        {/*</Nav>*/}
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    );
}
